import { render, staticRenderFns } from "./nubeComponent.vue?vue&type=template&id=8ba7e6b6&scoped=true&"
import script from "./nubeComponent.vue?vue&type=script&lang=js&"
export * from "./nubeComponent.vue?vue&type=script&lang=js&"
import style0 from "./nubeComponent.vue?vue&type=style&index=0&id=8ba7e6b6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba7e6b6",
  null
  
)

export default component.exports